module.exports = __webpack_public_path__ + "img/instagram-story.8a0e1e65.png";